export default __webpack_public_path__ + "static/media/guesty_lite_step3.6c096530.png";